import { render, staticRenderFns } from "./ShareRewardByLink.vue?vue&type=template&id=d0b138ee&"
import script from "./ShareRewardByLink.vue?vue&type=script&lang=ts&"
export * from "./ShareRewardByLink.vue?vue&type=script&lang=ts&"
import style0 from "./ShareRewardByLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports